import { Heading } from '@hungryroot/ramen';
import { buttonClickedEvent } from '@hungryroot/segment';
import {
  type AstroNavLinks,
  type SpaNavLinks,
} from '../CatalogNavigation/NavLinks';
import styles from './MobileMenuCards.module.css';

type navImage = {
  image: {
    src: string;
    alt: string;
  };
};

type Props = {
  navLinks: (AstroNavLinks & navImage)[] | (SpaNavLinks & navImage)[];
};

export function MobileMenuCards({ navLinks }: Props) {
  return (
    <div className={styles.container}>
      <Heading variant="H3" className={styles.heading}>
        Explore our catalog
      </Heading>
      <nav className={styles.nav}>
        {navLinks.map((link) => {
          const { text } = link;
          const buttonName = `${text.toLowerCase()}_menu`;

          if ('href' in link) {
            return (
              <a
                key={text}
                href={link.href}
                className={styles.link}
                aria-label={text}
                onClick={() => {
                  buttonClickedEvent({
                    button_name: buttonName,
                    order_id: null,
                    page_position: '',
                  });
                }}
              >
                <Heading variant="H6" as="p">
                  {link.text}
                </Heading>
                <img
                  src={link.image.src}
                  alt={link.image.alt}
                  className={styles.image}
                />
              </a>
            );
          }

          return (
            <button
              key={text}
              type="button"
              onClick={() => {
                link.onClick();
                buttonClickedEvent({
                  button_name: buttonName,
                  order_id: null,
                  page_position: '',
                });
              }}
              className={styles.link}
              aria-label={text}
            >
              <Heading variant="H6" as="p">
                {link.text}
              </Heading>
              <img
                src={link.image.src}
                alt={link.image.alt}
                className={styles.image}
              />
            </button>
          );
        })}
      </nav>
    </div>
  );
}
